import React from 'react'
import { TabList, Tab, TabPanel } from 'shared/library/atoms/Tabs'
import TabsProvider from 'shared/providers/TabsProvider'
import { Text } from 'library/atoms/Typography'
import {
  StyleGuideMain,
  StyleGuideIdProps
} from 'shared/library/pages/StyleGuide'

const PROPS = {
  Description: () => (
    <Text as="div">
      The Tabs component allows for switching views, and can be easily
      controlled by the parent component.
      <br />
      <br />
      Where possible, an enum should be used to define the individual Tab{' '}
      <code>order</code> and <code>children</code> values.
    </Text>
  ),
  examples: [
    {
      title: 'Tabs',
      code: `() => {
  const TABS = {
    cats: {
      id: 'cats and permissions',
      index: 0,
    },
    dogs: {
      id: 'dogs',
      index: 1
    },
    rabbits: {
      id: 'rabbits',
      index: 2
    }
  }

  return (
    <TabsProvider>
      <TabList label="Animal tabs">
        <Tab index={TABS.cats.index}>{TABS.cats.id}</Tab>
        <Tab index={TABS.dogs.index}>{TABS.dogs.id}</Tab>
        <Tab index={TABS.rabbits.index}>{TABS.rabbits.id}</Tab>
      </TabList>
      <TabPanel index={TABS.cats.index}>Cat content here</TabPanel>
      <TabPanel index={TABS.dogs.index}>Dog content here</TabPanel>
      <TabPanel index={TABS.rabbits.index}>Rabbit content here</TabPanel>
    </TabsProvider>
  )
}`,
      scope: { TabList, Tab, TabPanel, TabsProvider }
    },
    {
      title: 'Default Tab Selected',
      code: `() => {
  const TABS = {
    cats: {
      id: 'cats',
      index: 0,
    },
    dogs: {
      id: 'dogs',
      index: 1
    },
    rabbits: {
      id: 'rabbits',
      index: 2
    }
  }

  return (
    <TabsProvider defaultTab={2}>
      <TabList label="Animal tabs">
        <Tab index={TABS.cats.index}>{TABS.cats.id}</Tab>
        <Tab index={TABS.dogs.index}>{TABS.dogs.id}</Tab>
        <Tab index={TABS.rabbits.index}>{TABS.rabbits.id}</Tab>
      </TabList>
      <TabPanel index={TABS.cats.index}>Cat content here</TabPanel>
      <TabPanel index={TABS.dogs.index}>Dog content here</TabPanel>
      <TabPanel index={TABS.rabbits.index}>Rabbit content here</TabPanel>
    </TabsProvider>
  )
}`,
      scope: { TabList, Tab, TabPanel, TabsProvider }
    }
  ]
}

const TabsStyleGuide = (props: StyleGuideIdProps) => (
  <StyleGuideMain {...props} {...PROPS} />
)

export default TabsStyleGuide
